import apiClient from './apiClient';

const oemApi = {
  addPartner: async (data) => {
    const formData = new FormData();
    
    Object.keys(data).forEach(key => {
      if (key === 'logo' && data[key]) {
        formData.append('logo', data[key]);
      } else if (key === 'stripeProductId' && Array.isArray(data[key])) {
        formData.append('stripeProductId', JSON.stringify(data[key]));
      } else if (key !== 'logo' && key !== 'refreshParams' && data[key] !== null && data[key] !== undefined) {
        formData.append(key, data[key]);
      }
    });

    const response = await apiClient.post('/partners/oem-partners', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  },

  getPartners: async (params = {}) => {
    const { limit = 10, page = 1, search = '', status = '', scanType = '' } = params;
    const response = await apiClient.get('/partners/oem-partners', {
      params: { limit, page, search, status, scanType }
    });
    return response.data;
  },

  editPartner: async (data) => {
    const { id, ...editData } = data;
    const formData = new FormData();
    
    Object.keys(editData).forEach(key => {
      if (key === 'logo' && editData[key]) {
        formData.append('logo', editData[key]);
      } else if (key === 'stripeProductId' && Array.isArray(editData[key])) {
        formData.append('stripeProductId', JSON.stringify(editData[key]));
      } else if (key !== 'logo' && key !== 'refreshParams' && editData[key] !== null && editData[key] !== undefined) {
        formData.append(key, editData[key]);
      }
    });

    const response = await apiClient.put('/partners/oem-partners', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: { id }
    });
    return response.data;
  },

  deletePartner: async (id) => {
    const response = await apiClient.delete('/partners/oem-partners', {
      data: { _id: id }
    });
    return response.data;
  },

  changeStatus: async (data) => {
    const { refreshParams, ...statusData } = data;
    const response = await apiClient.patch('/partners/oem-partners/status', statusData);
    return response.data;
  },

  getScanTypes: async () => {
    const response = await apiClient.get('/admin/scan-types');
    return response.data;
  },

  getOemNames: async () => {
    const response = await apiClient.get('/partners/oem-partners/names');
    return response.data;
  },

  resetPassword: async (data) => {
    const response = await apiClient.post('/partners/oem-partners/reset-password', {
      _id: data?._id,
      plainPassword: data.plainPassword
    });
    return response.data;
  },

  resendVerificationEmail: async (oemId) => {
    const response = await apiClient.post('/partners/oem-partners/resend-verification-email', {
      oemId
    });
    return response.data;
  }
};

export { oemApi };